export { ExpertBox, type ExpertBoxProps } from './ExpertBox';
export {
  expertBoxVariants,
  type ExpertBoxVariantProps,
} from './expert-box.variants';
